import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {Helper} from '../../helpers/helper.service';
import {HttpClient, HttpParams, HttpResponse} from '@angular/common/http';
import {map, catchError} from 'rxjs/operators';

@Injectable()
export class CreditInvoiceService {
  public httpOptions;

  constructor(private helper: Helper, private http: HttpClient) {
  }

  public getCreditInvoices(gridData = new HttpParams(), params = new HttpParams()) {
    return this.http.get<any>(environment.apiUrl + '/backoffice/credit-invoice/?' + gridData.toString())
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getPdf(invoiceId) {
    return this.http.get(environment.apiUrl + '/backoffice/credit-invoice/' + invoiceId + '/pdf', {
      responseType: 'arraybuffer' as 'json',
      observe: 'response'
    }).pipe(
      map((resp: HttpResponse<ArrayBuffer>) => {
        const contentDispositionHeader = resp.headers.get('content-disposition');
        if (!contentDispositionHeader) {
          throw new Error('Content-Disposition header is missing');
        }
        const parts = contentDispositionHeader.split(';');
        if (parts.length < 2) {
          throw new Error('Invalid Content-Disposition header format');
        }
        const result = parts[1].trim().split('=')[1];
        return {
          'url': window.URL.createObjectURL(new Blob([resp.body], {type: 'application/pdf'})), 
          'filename': result.replace(/"/g, '')
        };
      }),
      catchError(res => this.helper.catchError(res))
    );
  }

  public creditSelectedOrders(invoiceId, selectedOrderIds) {
    return this.http.post<any>(environment.apiUrl + '/backoffice/credit-invoice/' + invoiceId, {ids: selectedOrderIds})
      .pipe(catchError(res => this.helper.catchError(res)));
  }
}
